import { render, staticRenderFns } from "./Ocp.vue?vue&type=template&id=0f7ca21d&scoped=true&"
import script from "./Ocp.vue?vue&type=script&lang=js&"
export * from "./Ocp.vue?vue&type=script&lang=js&"
import style0 from "./Ocp.vue?vue&type=style&index=0&id=0f7ca21d&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7ca21d",
  null
  
)

export default component.exports